<template>
    <div id="contig_result">
        <div v-if="this.contig_id">
            <h1>{{contig_id}} contig info page</h1>
            <b-row>
                <b-col cols="8">
                    <div>
                        <h3 id="summary">Summary</h3>
                        <p>Contig id: {{contig_id}}</p>
                        <p>Proteins: <AnchoredLinks
                                part_url="/protein/"
                                :array="pep_list"
                                :dec="','"
                                :inner_link="true"/></p>
                        <p>Experiment id: <router-link :to="{path: `/exp/${experiment_id}`}">{{experiment_id}}</router-link></p>
                        <p>Length: {{length}}</p>
                    </div>

                    <div>
                        <h3 id="reference">Reference alignment</h3>
                        <p>Reference genome: {{reference_genome}}</p>
                        <p>Alignment type: {{alignment_type}}</p>
                        <b-btn v-if="alignment_type === 'unannotated'"
                                variant="link"
                                v-b-toggle.gmap-psl-collapse
                                style="padding-left: 0; border-left: 0;">
                            <p>Show alignment (gmap psl format) </p>
                        </b-btn>
                        <b-collapse id="gmap-psl-collapse">
                            <b-card class="bio_card">{{gmap_psl}}</b-card>
                        </b-collapse>
                    </div>

                    <div>
                        <h3 id="annotation">Annotation</h3>
                        <h5>Сoding potential calculator based on sequence intrinsic features
                            <a href="https://www.ncbi.nlm.nih.gov/pubmed/28521017">
                                <img src="../../public/question-mark-2x.png"/>
                            </a>
                        </h5>
                        <TreeInfo :nodes="this.CPC2"/>
                        <div v-if="this.transdecoder">
                            <h5>Find Coding Regions Within Transcripts</h5>
                            <b-card class="bio_card">{{transdecoder_out}}</b-card>
                        </div>
                    </div>

                    <div>
                        <h3 id="expression">Expression</h3>
                        <h5>Isoform expression</h5>
                        <TreeInfo :nodes="this.isoform_expression"/>
                        <h5>Gene expression</h5>
                        <TreeInfo :nodes="this.gene_expression"/>
                    </div>

                    <div>
                        <h3 id="seq">Sequence</h3>
                        <b-card class="bio_card">{{seq}}</b-card>
                    </div>

                </b-col>
                <b-col cols="4">
<!--Тут будет мини навигация по названиям -->
                        <div>
                            <b-navbar v-b-scrollspy style="position: fixed;">
                                <b-nav pills vertical>
                                    <b-nav-item href="#summary">Summary</b-nav-item>
                                    <b-nav-item href="#reference">Reference alignment</b-nav-item>
                                    <b-nav-item href="#annotation">Annotation</b-nav-item>
                                    <b-nav-item href="#expression">Expression</b-nav-item>
                                    <b-nav-item href="#seq">Sequence</b-nav-item>
                                </b-nav>
                          </b-navbar>
                        </div>
                    </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import TreeInfo from "../components/TreeInfo";
    import AnchoredLinks from "../components/AnchoredLinks";
    export default {
        name: "ContigResult",
        components: {AnchoredLinks, TreeInfo},
        data: function () {
            return {
                CPC2: undefined,
                alignment_type: undefined,
                pep_list: undefined,
                contig_id: undefined,
                experiment_id: undefined,
                gene_expression: undefined,
                gmap_psl: undefined,
                isoform_expression: undefined,
                length: undefined,
                reference_genome: undefined,
                seq: undefined,
                transdecoder: undefined
            }
        },
        computed:{
            transdecoder_out: function () {
                if (this.transdecoder === [] || !this.transdecoder) {
                    return ''
                }
                else {
                    return this.transdecoder.map(value => value.join('\t')).join('\n');
                }
            }
        },
        mounted() {
            axios.get(`/get/contig/${this.$route.params.id}`)
                .then(response => {
                    this.experiment_id = response.data['experiment_id'];
                    this.length = response.data['length'];
                    this.reference_genome = response.data['reference_genome'];
                    this.alignment_type = response.data['alignment_type'];
                    this.gmap_psl = response.data['gmap_psl'];
                    this.CPC2 = response.data['CPC2'];
                    this.transdecoder = response.data['transdecoder'];
                    this.isoform_expression = response.data['isoform_expression'];
                    this.gene_expression = response.data['gene_expression'];
                    this.seq = response.data['seq'];
                    this.contig_id = response.data['contig_short_id'];
                    this.pep_list = response.data['pep_list']
                })
        }
    }
</script>

<style scoped lang="scss">
    .bio_card {
        font-family: Courier, monospace;
        white-space: pre;
        font-size: 16px;
        overflow: auto;
    }
</style>